import React from 'react';
import styled from 'styled-components';
import invalidDrive from '../../images/Closed.svg';
import backgroundImg from '../../images/closedBackgound.svg';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-image: url(${backgroundImg});
  background-size: cover;

  img {
    width: 320px;
    margin-bottom: 8px;
  }

  h1 {
    margin: 0 0 16px 0;
    color: ${props => props.theme.textColor};
    font-size: 36px;
    font-weight: 400;
    text-align: center;
  }

  h3 {
    margin: 0;
    font-size: 24px;
    font-weight: 400;
    color: ${props => props.theme.textColor};
    text-align: center;

    a {
      color: ${props => props.theme.accent1Color};
      text-decoration: none;
    }
  }
`;

const InvalidDrive = () => (
  <Wrapper>
    <img src={invalidDrive} alt="college doesn't exist" />
    <h1>Sorry, registrations for this College are closed.</h1>
    <h3>
      Visit <a href="http://www.myanatomy.in/">MyAnatomy</a> to get more
      information.
    </h3>
  </Wrapper>
);

export default InvalidDrive;



// WEBPACK FOOTER //
// ./src/views/InvalidDrive/InvalidDrive.js